module.exports = __webpack_public_path__ + "img/menu.873a2a0d.svg";